import React from 'react';
import { FiStar, FiCpu, FiLayers, FiTarget, FiUsers, FiTool } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Activities = () => {
  const activities = [
    {
      icon: FiStar,
      title: "Creativity",
      description: "By encouraging innovative thinking and design exploration through art, music, and imaginative play",
      color: "from-pink-400 to-rose-500"
    },
    {
      icon: FiLayers,
      title: "Logical Thinking", 
      description: "Through step-by-step reasoning and structured problem-solving activities that build analytical skills",
      color: "from-purple-400 to-indigo-500"
    },
    {
      icon: FiCpu,
      title: "Cognitive Skills",
      description: "By linking concepts to real-world applications and fostering critical thinking abilities",
      color: "from-blue-400 to-cyan-500"
    },
    {
      icon: FiTool,
      title: "STEM Skills",
      description: "Science, Technology, Engineering & Mathematics via hands-on projects and interactive learning",
      color: "from-emerald-400 to-teal-500"
    },
    {
      icon: FiUsers,
      title: "Confidence & Focus",
      description: "As children present ideas and work in teams, building social skills and self-assurance",
      color: "from-orange-400 to-red-500"
    },
    {
      icon: FiTarget,
      title: "Problem Solving",
      description: "Tackling challenges with curiosity and perseverance, developing resilience and adaptability",
      color: "from-yellow-400 to-orange-500"
    }
  ];

  return (
    <section className="py-20 bg-white" id="activities">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Activities & 
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-teal-600"> Benefits</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Discover how our innovative programs nurture young minds through engaging, 
            hands-on activities that prepare children for future success.
          </p>
        </div>

        {/* Activities Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {activities.map((activity, index) => (
            <div
              key={activity.title}
              className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {/* Icon */}
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-r ${activity.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <SafeIcon icon={activity.icon} className="w-8 h-8 text-white" />
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-emerald-600 transition-colors duration-200">
                {activity.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {activity.description}
              </p>

              {/* Hover Effect */}
              <div className="mt-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className={`w-full h-1 bg-gradient-to-r ${activity.color} rounded-full`}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16" data-aos="fade-up" data-aos-delay="600">
          <p className="text-lg text-gray-600 mb-6">
            Ready to give your child the best start in life?
          </p>
          <a
            href="tel:+917416706111"
            className="inline-flex items-center space-x-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-8 py-4 rounded-2xl text-lg font-semibold hover:from-emerald-700 hover:to-teal-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <span>Schedule a Visit Today</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Activities;